import Quill from "quill";
import { useGetRangeFromAttrValue } from "./useGetRangeFromAttrValue";

export const useRemoveAttributeFromRanges = (
  quill: any,
  quillDelta: any,
  attribute: string,
  value: string,
  attributesToRemove: string[]
) => {
  const ranges = useGetRangeFromAttrValue(quillDelta, attribute, value);

  for (const r of ranges) {
    for (const attributeToRemove of attributesToRemove) {
      quill.formatText(
        r.index,
        r.length,
        {
          [attributeToRemove]:
            attributeToRemove == "bold" || attributeToRemove == "underline"
              ? false
              : null,
        },
        Quill.sources.USER as any
      );
    }
  }
};
